export interface DateFilters {
  fromDate: string;
  toDate: string;
}

export const emptyDateFilters = (): DateFilters => ({ fromDate: '', toDate: '' });
export const todayIso = () => new Date().toISOString().slice(0, 10);

// Collection reports default to the current month rather than all-time: with 100k+ bills in
// the database, an unfiltered query has to read the entire billing history, so it can never be
// fast. Callers can still clear the filter to view all-time totals when they need to.
const localIsoDate = (date: Date) =>
  `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

export const todayDateFilters = (): DateFilters => {
  const today = localIsoDate(new Date());
  return { fromDate: today, toDate: today };
};

// Birth, death, discharge and OPD/EMG/IPD patient reports open on the last one month: the same date last month
// through today (clamped to the previous month's last day, e.g. 31 Mar -> 28/29 Feb).
export const lastMonthDateFilters = (): DateFilters => {
  const today = new Date();
  const lastDayOfPreviousMonth = new Date(today.getFullYear(), today.getMonth(), 0).getDate();
  const monthAgo = new Date(today.getFullYear(), today.getMonth() - 1, Math.min(today.getDate(), lastDayOfPreviousMonth));
  return { fromDate: localIsoDate(monthAgo), toDate: localIsoDate(today) };
};

export const currentMonthDateFilters = (): DateFilters => {
  const now = new Date();
  const firstOfMonth = new Date(now.getFullYear(), now.getMonth(), 1).toISOString().slice(0, 10);
  return { fromDate: firstOfMonth, toDate: todayIso() };
};
